module.exports = __webpack_public_path__ + "instagram-tv.d981aad38f9a17cbb9557b272a193b7b.svg";